import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../service/user.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-token-details',
  imports: [
    NgIf
  ],
  templateUrl: './token-details.component.html',
  styleUrl: './token-details.component.scss'
})
export class TokenDetailsComponent {
  userId: any;
  tokenDetails: any;
  errorMessage: string | null = null;
  constructor(private dialogRef: MatDialogRef<TokenDetailsComponent>,
              private userService: UserService,
              @Inject(MAT_DIALOG_DATA) public data: { userId: string })  {
    this.userId = data.userId;
    this.loadTokenDetails();
  }

  onClose(action: 'cancel' = 'cancel') {
    this.dialogRef.close(action);
  }

  loadTokenDetails() {
    this.userService.getActiveLotteryToken(this.userId).subscribe({
      next: result => {
        if (result.body) {
          this.tokenDetails = result.body;
        }
      },
      error: err => {
        if(err.status === 400){
          this.errorMessage = "There are currently no active Tokens available";
        }
        else{
          this.errorMessage = err.message || "Something went wrong";
        }
      }
    })
  }

}
